module.exports = __webpack_public_path__ + "img/agir.91ba55eb.svg";